var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackBtnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.243,
    height: 17.596,
    viewBox: "0 0 16.243 17.596",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33001",
    "data-name": "Group 33001",
    transform: "translate(-638.7 -223.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M0,0,8.8,8.8,17.6,0Z",
    transform: "translate(654.943 223.305) rotate(90)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-2",
    "data-name": "path",
    d: "M313.111,876.78l-5.85,5.849,5.85,5.849-1.78,1.78-7.63-7.63,7.63-7.63Z",
    transform: "translate(335 -650.542)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackBtnIcon);
export default __webpack_public_path__ + "static/media/back_btn_icon.ea91c8b1517e15586ac9810e78c3f1bf.svg";
export { ForwardRef as ReactComponent };